<app-sidebar-base>
    <div sidebarTitle #sidebarTitle>
        <span>{{'PRINTERS.LIST.TITLE' | translate}}</span>
    </div>
    
    <ng-container sidebarActions #sidebarActions>
        <button mat-icon-button
            (click)="createNewPrinter()">
            <mat-icon>add</mat-icon>
        </button>
    </ng-container>
    
    <div sidebar id="sidebar-content">
        <app-sidebar-item id="general-item-content"
            [isSelected]="isSelected('GENERAL')"
            (click)="onSelectGeneral()">
            <mat-icon start>settings</mat-icon>
            <span title>{{ 'PRINTERS.LIST.GENERAL_SETTINGS' | translate }}</span>
        </app-sidebar-item>
    
        <div class="tw-contents" id='grouped-item-content' class="scroll-container tw-overflow-auto">
            @for (group of groupedPrintersArray; track group.key; let i= $index; let first = $first) {
                <app-sidebar-section 
                    [collapsible]="true"
                    [hasSelected]="isGroupSelected(group.value)"
                    titleSection="{{ 'PRINTERS.LIST.' + group.key.toUpperCase() | translate }}"  
                    >
                    @for (printer of group.value; track printer.id; let j = $index) {
                        <app-sidebar-item [id]="'printer-item-content-' + i + '-' + j"
                            [isSelected]="isSelected('PRINTER', printer.id)"
                            (click)="selectPrinter(printer, i, j); $event.stopPropagation()">
                            <mat-icon start>print</mat-icon>
                            <span title>{{ printer.name }}</span>
                            <span subtitle #subtitle>{{ printer.ip_address }}</span>
                        </app-sidebar-item>
                    }
                </app-sidebar-section>
            }
        </div>
    </div>
</app-sidebar-base>